import { AuditLogField } from "src/app/modules/core/decorators/decorators";

export class Override {
  [key: string]: any;
  siteId: number;
  siteName: string;
  properName: string;
  state: string;
  customerName: string;
  nvrName: string;
  cameraName: string;
  @AuditLogField
  date: string;
  @AuditLogField
  isHoliday: boolean;
  @AuditLogField
  startTime: string;
  @AuditLogField
  endTime: string;
  @AuditLogField
  notes: string;
  @AuditLogField
  isMonitored: boolean;
  vertical: string;
  // Contact?
  name: string;
  email: string[];
  address: string;
  phone: string;
  id: number;
  overrideId: number;
  type: number;
  createdBy: string;
  allDay: string; // this is used for export only
  detectionGroup: string;
  escalationGroup: string;
  vmsType: string;
  monitoredBy: string;
  monitoringType: string;
  overrideReasonTypeID: number;
  requestor: string;

  
  get emailString(): string {
    if (this.email !== undefined && this.email !== null && this.email.length > 0)
      return this.email.join(', ');

    return '';
  }

  get isAllDay(): boolean {
    // API time values can include fractional seconds, but must represent the full day.
    const isStartOfDay = /^00:00(?::00(?:\.\d+)?)?$/.test(this.startTime ?? '');
    const isEndOfDay = /^23:59(?::59(?:\.\d+)?)?$/.test(this.endTime ?? '');

    return isStartOfDay && isEndOfDay;
  }

  get overrideDate(): Date {
    return new Date(this.date);
  }

  get overrideHours(): string {
    return this.startTime.substring(0, 5) + ' - ' + this.endTime.substring(0, 5);
  }
}

export class OverrideResult {
  totalCount: number;
  headers: Array<Override>;
  details: Array<Override>;
}

export class OverrideNvr {
  deviceId!: number | undefined;
  cameras!: Array<number> | undefined;
  siteId!: number |  undefined;
  siteTypeId!: number |  undefined;
}

export class DeleteOverrideDto {
  overrideId: number;
  overrideDate: string | null;
  nvrs: Array<OverrideNvr> | null;
}

export enum OverrideType {
  All = 0,
  MonitoringSchedule = 1,
  GuardTour = 2
}


